import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/footer'; // Importa il componente Footer
import Home from './pages/Home';
import MaintenancePage from './pages/MaintenancePage';
import ChiSiamo from './pages/ChiSiamo';
import Eventi from './pages/Eventi';
import Contatti from './pages/Contatti';
import AppTerms from './pages/AppTerms';
import AppPrivacy from './pages/AppPrivacy';
import './App.css';
import Servizi from './pages/Servizi';
import Discordbot from './pages/Discordbot';
import NotFound from './pages/NotFound';
import ErrorBoundary from './components/ErrorBoundary';
import { HelmetProvider } from 'react-helmet-async';

function App() {
  return (
  <HelmetProvider>
    <ErrorBoundary>
      <Router>
        <div className="App">
          <Navbar />
          <div className="content">
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/chi-siamo" element={<MaintenancePage />} />
              {/* <Route path="/chi-siamo" element={<ChiSiamo />} /> */}
              <Route path="/eventi-tmp" element={<MaintenancePage />} />
              <Route path="/eventi" element={<Eventi />} />
              <Route path="/contatti" element={<Contatti />} />
              <Route path="/servizi" element={<Servizi />} />
              <Route path="/just4funapp-terms" element={<AppTerms />} />
              <Route path="/just4funapp-privacy" element={<AppPrivacy />} />
              <Route path="/j4f-app" element={<Discordbot />} />

              <Route path="/manutenzione" element={<MaintenancePage />} />

              {/* Rotte per 404 Not Found */}
              <Route path="*" element={<NotFound />} />
              <Route path="/npm-redirect/error" element={<NotFound />} />
            
            </Routes>
          </div>
          <Footer /> {/* Aggiungi il footer qui */}
        </div>
      </Router>
    </ErrorBoundary>
  </HelmetProvider>  
  );
}

export default App;
